import React, { Component } from 'react'

// Styles
import './sideMenuItem.scss'

class SideMenuItem extends Component {
  constructor (props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick () {
    console.log('SideMenuItem onClick triggered!')
    if (this.props.onClick !== null) {
      this.props.onClick()
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getSelectedStyle () {
    return ' element-sidemenu-item__label--selected'
  }

  getStyle (external = false) {
    const { inactive, selected, onClick, isTitle } = this.props
    let classes = 'element-sidemenu-item__label'

    if (inactive) {
      classes += ' element-sidemenu-item__label--inactive'
    }

    if (selected) {
      classes += this.getSelectedStyle()
    }

    if (onClick === null && !external) {
      classes += ' element-sidemenu-item__label--dormant'
    }

    if (isTitle) {
      classes += ' element-sidemenu-item__label--title'
    }

    return classes + this.getSizeClass()
  }

  renderLabel () {
    const { label, renderLabel } = this.props

    if (renderLabel !== null) {
      return renderLabel(label, this.getStyle(true), this.getSelectedStyle())
    }

    return (
      <div className={this.getStyle()} onClick={this.onClick}>
        {label}
      </div>
    )
  }

  render () {
    return (
      <div className='element-sidemenu-item'>
        {this.renderLabel()}
        {this.props.children}
      </div>
    )
  }
}

SideMenuItem.defaultProps = {
  size: 'l',
  label: null,
  selected: false,
  inactive: null,
  onClick: null,
  isTitle: false,
  renderLabel: null // () => {}
}

export default SideMenuItem



// WEBPACK FOOTER //
// ./src/app/shared/elements/sideMenuItem/index.js